import { ISMARTData } from "../../types";

export default {
  id: "smart-hq",
  text: [
    "As a S.M.A.R.T agent, your job is to hunt down crime and problems throughout the net.",
    "Use the arrows to scroll around the netmap. Click a node to examine it. Fight databattles against corporate security software to gain control over nodes and open up more areas of the map to explore. Winning databattles earns you credits that you can use to purchase new programs.",
  ],
} as ISMARTData;
